import React from 'react';
import Icon from '@/components/ui/AppIcon';

const challenges = [
  {
    id: 'chal-001',
    title: 'Sabah Kahvesi Serisi',
    desc: '5 gün üst üste sabah siparişi ver',
    progress: 3,
    total: 5,
    reward: 50,
    daysLeft: 4,
    badge: '🌅',
  },
  {
    id: 'chal-002',
    title: 'Frappuccino Sevgilisi',
    desc: 'Bu ay 3 Frappuccino satın al',
    progress: 1,
    total: 3,
    reward: 75,
    daysLeft: 12,
    badge: '🥤',
  },
  {
    id: 'chal-003',
    title: 'Yeni Tatları Dene',
    desc: 'Sezonluk 2 yeni ürünü dene',
    progress: 2,
    total: 2,
    reward: 100,
    daysLeft: 0,
    badge: '🍂',
    completed: true,
  },
];

export default function ActiveChallenges() {
  return (
    <div className="px-4 pb-4">
      <h2 className="text-foreground font-bold text-base mb-3">Aktif Görevler</h2>
      <div className="space-y-3">
        {challenges?.map((ch) => {
          const pct = Math.min(100, (ch?.progress / ch?.total) * 100);
          return (
            <div
              key={ch?.id}
              className={`bg-card rounded-2xl p-4 card-shadow border ${
                ch?.completed ? 'border-primary/30 bg-accent/30' : 'border-transparent'
              }`}
            >
              <div className="flex items-start gap-3">
                <span className="text-2xl">{ch?.badge}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <p className="text-foreground font-bold text-sm">{ch?.title}</p>
                    <div className="flex items-center gap-1 flex-shrink-0">
                      <Icon name="StarIcon" size={12} variant="solid" className="text-gold" />
                      <span className="text-gold font-bold text-xs">+{ch?.reward}★</span>
                    </div>
                  </div>
                  <p className="text-muted-foreground text-xs mb-2">{ch?.desc}</p>

                  {/* Progress bar */}
                  <div className="flex items-center gap-2">
                    <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                      <div
                        className={`h-full rounded-full transition-all duration-500 ${
                          ch?.completed ? 'bg-primary' : 'bg-gold'
                        }`}
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <span className="text-xs font-semibold text-muted-foreground font-tabular">
                      {ch?.progress}/{ch?.total}
                    </span>
                  </div>

                  {ch?.completed ? (
                    <div className="flex items-center gap-1 mt-2">
                      <Icon name="CheckCircleIcon" size={14} variant="solid" className="text-primary" />
                      <span className="text-primary text-xs font-semibold">Tamamlandı!</span>
                    </div>
                  ) : (
                    <p className="text-muted-foreground text-[10px] mt-1">{ch?.daysLeft} gün kaldı</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}